import { createFileRoute } from '@tanstack/react-router';

import Register from '~/features/auth/routes/Register.route';

export const Route = createFileRoute('/_auth/register/')({
    component: () => <Register />,
});
